import { useEffect } from 'react';
import { Form } from 'semantic-ui-react';
import { FormNumberInput, FormSchemaAwareWidget } from '~/components/form';
import { FeeUnits, FeeUnitsDropdownOptions, StorageFeeUnitsDropdownOptions } from '~/constants';
import { useForm } from '~/hooks';
import './styles.scss';

const FeeForms = () => {
  const { formState, updateFormValue } = useForm();
  const hasSellerProjectFee = formState?.sellerFeeUnit === FeeUnits.PERCENT_OF_BUDGET || formState?.sellerFeeUnit === FeeUnits.PERCENT_OF_ITC;
  const hasBuyerProjectFee = formState?.nrsFeeUnit === FeeUnits.PERCENT_OF_BUDGET || formState?.nrsFeeUnit === FeeUnits.PERCENT_OF_ITC;

  const handleClearInput = async (schemaKeys: string[]) => {
    for (const key of schemaKeys) {
      await updateFormValue(key, null); // Await each update to ensure proper state updates
    }
  };

  useEffect (() => {
    if (hasSellerProjectFee) {
      handleClearInput(['sellerStorageFee', 'sellerStorageFeeUnit']);
    }
    if (hasBuyerProjectFee) {
      handleClearInput(['buyerStorageFee', 'buyerStorageFeeUnit']);
    }
  }, [hasSellerProjectFee, hasBuyerProjectFee]);

  return (
    <Form className="fee-form">
      <Form.Group className="fee-form-group">
        <label className="fee-form-label">
          Seller fee - PV
          <span
            className="clear-input"
            onClick={() => handleClearInput(['sellerFee', 'sellerFeeUnit'])}
          >
            (Clear input)
          </span>
        </label>
        <div className="input-container">
          <FormNumberInput
            schemaKey='sellerFee'
            inputStyle={{ color: 'var(--color-charcoal)' }}
            placeholder='Amount...'
          />
          <FormSchemaAwareWidget
            schemaKey='sellerFeeUnit'
            placeholder='Unit...'
            options={FeeUnitsDropdownOptions}
            selectOnBlur={false}
          />
        </div>
      </Form.Group>
      <Form.Group className="fee-form-group">
        <label className="fee-form-label">
          Seller fee - BESS
          <span
            className="clear-input"
            onClick={() => handleClearInput(['sellerStorageFee', 'sellerStorageFeeUnit'])}
          >
            (Clear input)
          </span>
        </label>
        <div className="input-container">
          <FormNumberInput
            schemaKey='sellerStorageFee'
            inputStyle={{ color: 'var(--color-charcoal)' }}
            placeholder='Amount...'
            disabled={hasSellerProjectFee}
          />
          <FormSchemaAwareWidget
            schemaKey='sellerStorageFeeUnit'
            placeholder='Unit...'
            options={StorageFeeUnitsDropdownOptions}
            selectOnBlur={false}
            disabled={hasSellerProjectFee}
          />
        </div>
      </Form.Group>
      <Form.Group className="fee-form-group">
        <label className="fee-form-label">
          Buyer fee - PV
          <span
            className="clear-input"
            onClick={() => handleClearInput(['nrsFee', 'nrsFeeUnit'])}
          >
            (Clear input)
          </span>
        </label>
        <div className="input-container">
          <FormNumberInput
            schemaKey='nrsFee'
            inputStyle={{ color: 'var(--color-charcoal)' }}
            placeholder='Amount...'
          />
          <FormSchemaAwareWidget
            schemaKey='nrsFeeUnit'
            placeholder='Unit...'
            options={FeeUnitsDropdownOptions}
            selectOnBlur={false}
          />
        </div>
      </Form.Group>
      <Form.Group className="fee-form-group">
        <label className="fee-form-label">
          Buyer fee - BESS
          <span
            className="clear-input"
            onClick={() => handleClearInput(['buyerStorageFee', 'buyerStorageFeeUnit'])}
          >
            (Clear input)
          </span>
        </label>
        <div className="input-container">
          <FormNumberInput
            schemaKey='buyerStorageFee'
            inputStyle={{ color: 'var(--color-charcoal)' }}
            placeholder='Amount...'
            disabled={hasBuyerProjectFee}
          />
          <FormSchemaAwareWidget
            schemaKey='buyerStorageFeeUnit'
            placeholder='Unit...'
            options={StorageFeeUnitsDropdownOptions}
            selectOnBlur={false}
            disabled={hasBuyerProjectFee}
          />
        </div>
      </Form.Group>
    </Form>
  );
};

export default FeeForms;